module.exports = __webpack_public_path__ + "static/media/18ECA5.2c951744.jpg";